var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RequireJob',{attrs:{"dataJob":_vm.recruiment,"skills":_vm.skills}}),_c('BenefitPackage'),_c('Opportunities',{attrs:{"data":_vm.item_filter}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }